import APIKey from '@/views/admin/APIKey.vue'
import APIKeys from '@/views/admin/APIKeys.vue'
import APIRole from '@/views/admin/APIRole.vue'
import APIRoles from '@/views/admin/APIRoles.vue'
import FeatureFlags from '@/views/admin/FeatureFlags.vue'
import Notifications from '@/views/admin/Notifications.vue'
import NotificationSubscriber from '@/views/admin/Notification/Subscriber.vue'
import NotificationSubscribers from '@/views/admin/Notification/Subscribers.vue'
import Sessions from '@/views/admin/Sessions.vue'
import User from '@/views/admin/User.vue'
import Users from '@/views/admin/Users.vue'

import * as Breadcrumbs from '../breadcrumbs/admin'

export default [
	{
		path: '/api-keys',
		name: 'api-keys',
		component: APIKeys,
		meta: {
			requiresAuth: true,
			title: 'API Keys',
			breadcrumb: [
				Breadcrumbs.APIKeys,
			],
		},
	}, {
		path: '/api-keys/:key',
		name: 'api-key',
		component: APIKey,
		meta: {
			requiresAuth: true,
			title: 'API Keys',
			breadcrumb: [
				Breadcrumbs.APIKeys,
				Breadcrumbs.APIKey,
			],
		},
	}, {
		path: '/apiroles/',
		name: 'api-roles',
		component: APIRoles,
		meta: {
			requiresAuth: true,
			title: 'API Roles',
			breadcrumb: [
				Breadcrumbs.APIRoles,
			],
		},
	}, {
		path: '/api-roles/:role',
		name: 'api-role',
		component: APIRole,
		meta: {
			requiresAuth: true,
			title: 'API Roles',
			breadcrumb: [
				Breadcrumbs.APIRoles,
				Breadcrumbs.APIRole,
			],
		},
	}, {
		path: '/feature-flags',
		name: 'feature-flags',
		component: FeatureFlags,
		meta: {
			requiresAuth: true,
			title: 'Feature Flags',
			breadcrumb: [
				Breadcrumbs.FeatureFlags,
			],
		},
	}, {
		path: '/notifications',
		name: 'notifications',
		component: Notifications,
		meta: {
			requiresAuth: true,
			title: 'Notifications',
			breadcrumb: [
				Breadcrumbs.Notifications,
			],
		},
	}, {
		path: '/notifications/:group',
		name: 'subscribers',
		component: NotificationSubscribers,
		meta: {
			requiresAuth: true,
			title: 'Notifications',
			breadcrumb: [
				Breadcrumbs.Notifications,
				Breadcrumbs.NotificationSubscribers,
			],
		},
	}, {
		path: '/notifications/:group/:subscriber',
		name: 'subscriber',
		component: NotificationSubscriber,
		meta: {
			requiresAuth: true,
			title: 'Notifications',
			breadcrumb: [
				Breadcrumbs.Notifications,
				Breadcrumbs.NotificationSubscribers,
				Breadcrumbs.NotificationSubscriber,
			],
		},
	},
	{
		path: '/sessions/',
		name: 'sessions',
		component: Sessions,
		meta: {
			requiresAuth: true,
			title: 'Sessions',
			breadcrumb: [
				Breadcrumbs.Sessions,
			],
		},
	},
	{
		path: '/users',
		name: 'users',
		component: Users,
		meta: {
			requiresAuth: true,
			title: 'Users',
			breadcrumb: [
				Breadcrumbs.Users,
			],
		},
	}, {
		path: '/users/:user',
		name: 'user',
		component: User,
		meta: {
			requiresAuth: true,
			title: 'Users',
			breadcrumb: [
				Breadcrumbs.Users,
				Breadcrumbs.User,
			],
		},
	},
]
